import React from "react";
import { DataGrid, GridColDef, GridSortModel } from "@mui/x-data-grid";
import { ApiResponse } from "../../../services/api";
import CargoSearchList from "../../../types/cargoSearchList";

interface CargoSearchListTableProps {
  rows: any[];
  columns: GridColDef[];
  width?: string;
  getRowClassName?: (params: { indexRelativeToCurrentPage: number }) => string;
  apiResponse: ApiResponse<CargoSearchList> | null;
  paginationModel: any;
  setPaginationModel: any;
  sortModel?: GridSortModel;
  onSortModelChange?: (model: GridSortModel) => void;
}

const CargoSearchListTable: React.FC<CargoSearchListTableProps> = ({
  rows,
  columns,
  width = "100%",
  getRowClassName,
  apiResponse,
  paginationModel,
  setPaginationModel,
  sortModel,
  onSortModelChange,
}) => {
  return (
    <div style={{ height: '100%', width, display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        rowHeight={36}
        columnHeaderHeight={40}
        pageSizeOptions={[10, 20, 40, 100]}
        pagination
        checkboxSelection={false}
        getRowClassName={getRowClassName}
        paginationMode='server'
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={apiResponse?.data?.totalItems ?? 0}
        sortingMode='server'
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#f5f5f5",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#b2d1ff",
          }, 
          "& .MuiTablePagination-selectLabel": {
            marginTop: "14px",
          },
          "& .MuiTablePagination-displayedRows": {
            marginTop: "14px",
          },
          "& .MuiDataGrid-cell[id='id']": {
            cursor: 'pointer !important',
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
            outline: "none",
          }
        }}
      />
      </div>
    </div>
  );
};

export default CargoSearchListTable;
